import React, { useEffect, useState, useContext } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import Keyboard from '../utils/Keyboard';
//Context
import UserContext from "../../context/UserContext";

//Api 
import { AuthFetchAPI } from '../../api/Auth';
import { UsersFetchAPI } from '../../api/Users';
import { BusinessFetchAPI } from '../../api/Business';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { MachinesFetchAPI } from '../../api/Machines';
import { getStartupPath } from '../utils/resolveStartupRoute';
//Components
import Swal from "sweetalert2";
//Img
import logo_sp from '../img/logos/icon-black.png';

//Utils 
import { RenderIf } from '../utils/RenderIf'
// Estilos del rediseño (solo visual)
import './login.css';

// Helper SOLO visual para iniciales de avatar (no es lógica de negocio)
const splInitials = (name = '') =>
    name.trim().split(/\s+/).map(w => w[0] || '').slice(0, 2).join('').toUpperCase();


const Login = () => {
    //States 
    const [passwordUser, setPasswordUser] = useState('');
    const [showVirtualKeyboard, setShowVirtualKeyboard] = useState(true);
    const [showPassword, setShowPassword] = useState(true)
    const [dataGeneralUserNow, setDataGeneralUserNow] = useState(null)
    const [selectedUser, setSelectedUser] = useState(null);
    const [businessData, setBusinessData] = useState({
        name: '',
        id: 0
    });
    const [users, setUsers] = useState([]);
    const [statusAuth, setStatusAuth] = useState(false);

    //Context 
    const { setUserData } = useContext(UserContext);
    //Params
    const { business_code, branchoffice_code, machine_code } = useParams();
    //Navigation
    const navigate = useNavigate();
    //Location page 
    const url_path = useLocation();

    const toogglePasword = () => {
        setShowPassword((prev) => !prev);
    }

    //Function to get the initial data 
    const getInitialData = async (business_code) => {
        //Variables
        let response_business = '';
        try {
            //We get the business
            response_business = await BusinessFetchAPI.getBusinessByCode(business_code)
            //We set the business data 
            setBusinessData(response_business.data.business)
        } catch (err) {
            //If we get some error we redirect to a no mactch page 
            navigate('/nomatch')
        }
    }

    function areMachineLocalStorageValuesLoaded() {
        const requiredKeys = [
            "x-access-machine-token",
            "business",
            "branchoffice",
            "branchoffice_original",
            "machine",
            "machine_original"
        ];
        for (const key of requiredKeys) {
            const value = localStorage.getItem(key);
            if (
                value === null ||
                value === undefined ||
                value === "" ||
                value === "undefined" ||
                value === "null"
            ) {
                return false;
            }
        }
        return true;
    }

    const signout = async () => {
        let machine_token = localStorage.getItem('x-access-machine-token');
        let machine = JSON.parse(localStorage.getItem('machine_original'));

        //We logout the machine 
        try {
            const response = await MachinesFetchAPI.updateMachineStatus(machine.code, false, machine_token)

            if (response.data.success == true) {
                //We delete the tokens 
                localStorage.setItem('x-access-token', "");
                localStorage.setItem('x-access-machine-token', "");

                //We delete the machine and user info 
                localStorage.setItem('user', "");
                localStorage.setItem('machine', "");
                localStorage.setItem('branchoffice', "");
                localStorage.setItem('business', "");
                localStorage.setItem('table', "");
                localStorage.removeItem("generalData");
                localStorage.removeItem("codeParthner");
                localStorage.removeItem("external_menu_manual");
                localStorage.removeItem("table");
                localStorage.removeItem("waiters");
                navigate(`/machines/login/${business_code}`);
                //We redirect to the login of the users on the payment post 
            }
        } catch (err) {
            console.log(err)
        }
    }

    //Function to get the users of a branchoffice or a business depending the role 
    const getUsers = async (branchoffice_id) => {
        try {

            let response = await UsersFetchAPI.getUsersByPermissionAccess(branchoffice_id, "pos_login", localStorage.getItem('x-access-machine-token'));
            setUsers(response.data.users);
        } catch (err) {
            //If we get some error we set the users data empty 
            setUsers([])
        }
    }

    // Performs the actual /auth/login call, tagging it with this browser's current machine so the
    // backend can detect a conflicting session on another terminal (see controller.login on the
    // dashboard). forceTransfer is only ever true on the retry after the cashier confirms the dialog.
    const attemptLogin = async (user_logged, forceTransfer) => {
        const machine = JSON.parse(localStorage.getItem('machine') || 'null');
        const branchoffice = JSON.parse(localStorage.getItem('branchoffice') || 'null');

        const response = await AuthFetchAPI.login({
            ...user_logged,
            machine_id: machine?.id,
            machine_code: machine?.code,
            machine_name: machine?.machine_name || machine?.code,
            branchoffice_id: branchoffice?.id,
            branchoffice_code: branchoffice?.code,
            force_transfer: forceTransfer === true,
        });

        //We get the token and user data
        let token = response.data.token;
        let user = response.data.user;
        //We set the user info and the token access
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('user_original', JSON.stringify(user));
        localStorage.setItem('x-access-token', token);
        //We set the context of the user
        setUserData({ token, user: user });

        if (areMachineLocalStorageValuesLoaded() == true) {
            navigate(getStartupPath(business_code, branchoffice_code))
        }
    }

    //Event to login
    const submit = async (e) => {
        e.preventDefault();
        // Validar selección de usuario y sucursal
        if ((url_path.pathname.includes('cashier') && branchoffice_code !== null) || (url_path.pathname.includes('dispatcher') && branchoffice_code !== null) || (!url_path.pathname.includes('dispatcher') || !url_path.pathname.includes('cashier') && branchoffice_code === undefined || branchoffice_code === null)) {
            let user_logged;
            if (dataGeneralUserNow && typeof dataGeneralUserNow === 'object' && Object.keys(dataGeneralUserNow).length > 0) {
                // Si hay datos generales del usuario, usarlos
                user_logged = { ...dataGeneralUserNow };
                // Si falta el campo 'pass', tomarlo del input
                if (!user_logged.pass) {
                    const form = new FormData(e.target);
                    user_logged.pass = form.get('pass');
                }
            } else {
                // Si no, usar los datos del formulario
                const form = new FormData(e.target);
                user_logged = Object.fromEntries(form.entries());
            }
            user_logged.business_id = businessData.id;
            console.log(user_logged)
            try {
                await attemptLogin(user_logged, false);
            } catch (err) {
                // Single-session-per-cashier: this user already has a session open on another
                // terminal. Offer to move it here instead of just failing the login outright.
                if (err.response?.status === 409 && err.response?.data?.code === 'USER_ALREADY_LOGGED_ELSEWHERE') {
                    const otherMachine = err.response.data.data || {};
                    const result = await Swal.fire({
                        icon: 'warning',
                        title: 'Sesion activa en otra terminal',
                        text: `Este usuario ya tiene una sesion abierta en la maquina "${otherMachine.machine_name || otherMachine.machine_code || 'otra terminal'}"${otherMachine.branchoffice_name ? ` de la sucursal "${otherMachine.branchoffice_name}"` : ''}. Si continuas, esa sesion se cerrara.`,
                        showCancelButton: true,
                        confirmButtonText: 'Cerrar y continuar aqui',
                        cancelButtonText: 'Cancelar',
                        reverseButtons: true,
                    });

                    if (result.isConfirmed) {
                        try {
                            await attemptLogin(user_logged, true);
                        } catch (retryErr) {
                            Swal.fire({
                                icon: "error",
                                title: retryErr.response?.data?.error || 'No fue posible iniciar sesion',
                                showConfirmButton: false,
                                timer: 1500,
                            });
                            setPasswordUser('');
                        }
                    } else {
                        setPasswordUser('');
                    }
                    return;
                }

                Swal.fire({
                    icon: "error",
                    title: err.response?.data?.error || 'No fue posible iniciar sesion',
                    showConfirmButton: false,
                    timer: 1500,
                });
                setPasswordUser('');
            }
        } else {
            //If the user dont select any branch we throw an error
            Swal.fire({
                icon: "error",
                title: 'Seleccione una sucursal',
                showConfirmButton: false,
                timer: 1500,
            });
        }
    }


    //Event to login a machine 
    const loginMachine = async () => {
        //We set the form data object 

        if (statusAuth == false) {
            setStatusAuth(true)
            const form = new FormData();
            form.append('branchoffice_code', branchoffice_code);
            form.append('business_code', business_code);
            form.append('machine_code', machine_code);
            let machine = Object.fromEntries(form.entries());
            try {
                const response = await AuthFetchAPI.loginSmartPay(machine);
                setStatusAuth(false)
                //We get the token and user data 
                let token = response.data.token;
                let business = response.data.business;
                let branchoffice = response.data.branchoffice;
                let machine_info = response.data.machine
                //We set the token info and the token access 
                localStorage.setItem('x-access-machine-token', token);
                localStorage.setItem('business', JSON.stringify(business));
                localStorage.setItem('branchoffice', JSON.stringify(branchoffice));
                localStorage.setItem('branchoffice_original', JSON.stringify(branchoffice));
                localStorage.setItem('machine', JSON.stringify(machine_info));
                localStorage.setItem('machine_original', JSON.stringify(machine_info));

                //We get the users of the branch 
                getUsers(branchoffice.id, branchoffice.code);
            } catch (err) {
                setStatusAuth(false)
                console.log(err)
                //If the machine login send any error we check if the data already exist on the browser 
                let business = localStorage.getItem('business');
                let branchoffice = localStorage.getItem('branchoffice');
                let machine = localStorage.getItem('machine');
                //We check if the data is empty 
                if ((machine === '' && branchoffice === '' && business === '') || (machine === null && branchoffice === null && business === null) || (err.response.data.error && err.response.data.error === 'Machine code not found, try again')) {
                    navigate(`/machines/login/${business_code}`)
                } else {
                    let branch = JSON.parse(branchoffice)
                    getUsers(branch.id, branch.code);
                    console.log('Ya se logeo una maquina aqui, en esta computadora')
                }
            }

        }

    }

    //Hook to get data when the page is loaded
    useEffect(() => {
        if (machine_code === undefined) {
            //We get the business by code 
            getInitialData(business_code);
            //We get the user data 
            let branchoffice = localStorage.getItem('branchoffice')
            let branch = JSON.parse(branchoffice)
            getUsers(branch.id);
        } else {
            loginMachine()
        }

    }, []);

    useEffect(() => {

        let urlNow = window.location.href + ""
        let arrayParams = urlNow.split('/');
        console.log(arrayParams[3] + " " + arrayParams[4] + " " + arrayParams[5]);

        if (arrayParams[3] == "machine" && arrayParams[4] == "cashier" && arrayParams[5] == "login") {
            if (localStorage.getItem("x-access-token") == "" || localStorage.getItem("x-access-token") == undefined || localStorage.getItem("x-access-machine-token") == "" || localStorage.getItem("x-access-machine-token") == undefined || localStorage.getItem("branchoffice") == "" || localStorage.getItem("branchoffice") == undefined || localStorage.getItem("machine") == "" || localStorage.getItem("machine") == undefined || localStorage.getItem("user") == "" || localStorage.getItem("user") == undefined) {

            } else {
                let branchoffice = JSON.parse(localStorage.getItem('branchoffice'));
                let machine = JSON.parse(localStorage.getItem('machine'));
                let business = JSON.parse(localStorage.getItem("business"));

                //console.log(`/kiosk/${business.code}/${branchoffice.code}`);
                navigate(getStartupPath(business.code, branchoffice.code))
            }
        }

    }, []);



    // "Ocupado" = the cashier already has a session open on another terminal. Selecting them is
    // still allowed: the login flow asks to move the session here (USER_ALREADY_LOGGED_ELSEWHERE).
    const isBusyUser = (user) => {
        if (user.is_logged !== 1) return false;
        const machine = JSON.parse(localStorage.getItem('machine') || 'null');
        return !machine?.code || String(user.logged_machine_code) !== String(machine.code);
    }

    //Function to list the users of branchoffice
    const listUsers = () => {
        // MOBILE: siempre muestra la lista
        if (window.innerWidth < 768) {
            return (
                <div className="spl-list">
                    {users.map((data) => (
                        <React.Fragment key={data.user_id}>
                            <input
                                type="radio"
                                className="spl-choice"
                                name="email"
                                id={data.user_id}
                                value={data.email}
                                onChange={() => { setSelectedUser(data.user_id); setDataGeneralUserNow(data); }}
                                checked={selectedUser === data.user_id}
                            />
                            <label className="spl-row" htmlFor={data.user_id}>
                                <span className="spl-avatar">{splInitials(data.user_name)}</span>
                                <span className="spl-rtext"><span className="spl-r1">{data.user_name} {isBusyUser(data) && (<span className="spl-badge spl-busy">Ocupado</span>)}</span></span>
                                <span className="spl-radio">
                                    <svg width="11" height="11" viewBox="0 0 12 12" fill="none"><path d="M2.5 6.2 5 8.6l4.5-5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                </span>
                            </label>


                        </React.Fragment>
                    ))}
                </div>


            );
        }
        // DESKTOP: si hay usuario seleccionado, el usuario y "cambiar" se muestran en el título (mensaje 4)
        if (selectedUser) {
            return null;
        }
        // DESKTOP: si no hay usuario seleccionado, mostrar lista
        return (
            <div className="spl-list">
                {users.map((data) => (
                    <React.Fragment key={data.user_id}>
                        <input
                            type="radio"
                            className="spl-choice"
                            name="email"
                            id={data.user_id}
                            value={data.email}
                            onChange={() => { setSelectedUser(data.user_id); setDataGeneralUserNow(data); }}
                            checked={selectedUser === data.user_id}
                        />
                        <label className="spl-row" htmlFor={data.user_id}>
                            <span className="spl-avatar">{splInitials(data.user_name)}</span>
                            <span className="spl-rtext"><span className="spl-r1">{data.user_name} {isBusyUser(data) && (<span className="spl-badge spl-busy">Ocupado</span>)}</span></span>
                            <span className="spl-radio">
                                <svg width="11" height="11" viewBox="0 0 12 12" fill="none"><path d="M2.5 6.2 5 8.6l4.5-5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
                            </span>
                        </label>
                    </React.Fragment>
                ))}
            </div>
        );
    }


    return (
        <div className="spl-page">

            {/* Degradado superior (verde -> azul) */}
            <div className="spl-topglow" aria-hidden="true"></div>

            {/* Nav superior */}
            <nav className="spl-nav">
                <span className="spl-brand">
                    SmartPay <span className="spl-pos">POS</span>
                </span>
                <span className="spl-company">{businessData.name}</span>
            </nav>

            <main className="spl-content">
                <div className="spl-wrap">

                    <div className="spl-eyebrow">Inicio de Sesión</div>

                    {/**List and form of users depending the branchoffice */}
                    <RenderIf isTrue={url_path.pathname.includes('cashier') || url_path.pathname.includes('dispatcher')}>
                        {/*Form */}
                        <form onSubmit={submit} className="spl-form" noValidate>
                            {selectedUser ? (
                                <>
                                    <h1 className="spl-title">Ingresa tu contraseña</h1>
                                    <p className="spl-sub">Iniciando como <strong>{users.find(u => u.user_id === selectedUser)?.user_name || ''}</strong> · <button type="button" className="spl-sublink" onClick={() => setSelectedUser(null)}>cambiar</button></p>
                                </>
                            ) : (
                                <>
                                    <h1 className="spl-title">¿Quién va a iniciar sesión?</h1>
                                    <p className="spl-sub">Selecciona tu usuario para continuar.</p>
                                </>
                            )}

                            {listUsers()}

                            <div style={{ marginTop: '20px' }}>
                                {/* MOBILE: Siempre visible */}
                                <div className="d-block d-md-none">
                                    <label className="spl-lbl" htmlFor="password">Contraseña</label>
                                    <input
                                        spellCheck="false"
                                        className="spl-input"
                                        id="password"
                                        type="password"
                                        name='pass'
                                        placeholder="Ingresar contraseña"
                                        value={passwordUser}
                                        onChange={(e) => setPasswordUser(e.target.value)}
                                        required
                                        readOnly={false}
                                        tabIndex="0"
                                    />
                                    {/* El teclado virtual NO se muestra en mobile */}
                                </div>
                                {/* DESKTOP/TABLET: Solo si usuario seleccionado */}
                                {selectedUser && (
                                    <div className="d-none d-md-block">
                                        <label className="spl-lbl" htmlFor="password">Contraseña</label>
                                        <input
                                            spellCheck="false"
                                            className="spl-input"
                                            id="password"
                                            type={showPassword ? 'password' : 'text'}
                                            name='pass'
                                            placeholder="Ingresar contraseña"
                                            value={passwordUser}
                                            onChange={(e) => setPasswordUser(e.target.value)}
                                            required
                                            readOnly={showVirtualKeyboard}
                                            tabIndex={showVirtualKeyboard === true ? "0" : "-1"}
                                        />
                                        <div className="spl-kb-host">
                                            <Keyboard txt={passwordUser} setTxt={setPasswordUser} showVirtualKeyboard={showVirtualKeyboard} setShowVirtualKeyboard={setShowVirtualKeyboard} />
                                        </div>

                                        <label className="spl-checkrow">
                                            <input type="checkbox"
                                                value="remember-me" id="flexCheckDefault"
                                                onChange={toogglePasword}
                                            />
                                            <span className="spl-cbox">
                                                <svg width="11" height="11" viewBox="0 0 12 12" fill="none"><path d="M2.5 6.2 5 8.6l4.5-5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                            </span>
                                            <span>Mostrar contraseña</span>
                                        </label>
                                    </div>
                                )}
                            </div>

                            <div className="spl-actions">
                                <button className="spl-back" type="button" onClick={() => signout()}>← Volver</button>
                                <button className="spl-btn spl-btn-primary" type="submit">Ingresar</button>
                            </div>
                        </form>
                    </RenderIf>

                </div>
            </main>

            {/* Footer */}
            <footer className="spl-footer">
                <div className="spl-footer-in">
                    <span className="spl-fbrand">
                        SmartPay <span className="spl-pos">POS</span>
                    </span>
                    <nav className="spl-flinks">
                        <a href="#">Privacidad</a>
                        <a href="#">Términos</a>
                        <a href="#">Soporte</a>
                    </nav>
                    <span className="spl-fcopy">© 2026 ·</span>
                </div>
            </footer>

        </div>
    )
}

export default Login